<template>
  <!-- eslint-disable max-len -->
  <button
    class="rounded-full py-3 px-12 shadow-lg text-4 md:text-3 button-hover text-white leading-none"
    :class="[{ 'button-hover-enable': !disableHover }, bgGray ? 'bg-gray text-black' : 'bg-theme1']"
    @click="$emit('click')"
  >
    {{ computedText }}
    <slot />
  </button>
</template>

<script>
import { global } from '@io';

export default {
  name: 'CoreButton',

  props: {
    text: {
      type: String,
      default: null,
    },
    disableHover: {
      type: Boolean,
      default: false,
    },
    bgGray: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    cta: '',
    data: null,
  }),

  computed: {
    // Slot will take precidence
    // Defaults to CTA text set in CMS if no text prop provided
    computedText() {
      if (typeof this.$slots.default !== 'undefined') return '';
      if (!!this.text === true) return this.text;
      return this.cta;
    },
  },

  async created() {
    this.cta = await global.get('ctaText');
  },
};
</script>

<style scoped>
.button-hover {
  transition-property: all;
  transition-duration: var(--transition-long);
  transition-timing-function: var(--transition-ease);
}

.button-hover-enable:hover {
  transform: scale(1.05);
  /* color: ; */
  /* background-color: black; */
}

/* Cascade */
.text-black {
  color: black;
}

.button-hover-enable:hover.bg-gray {
  background-color: theme('colors.theme1');
  color: white;
}
</style>
